import React, { useEffect, useState } from "react";
import Sales from "./sub-tabs/sales";
import HR from "./sub-tabs/hr";
import EOW from "./sub-tabs/eow";
import { contactUSkeys } from "../../../../../config";
import { Tabs } from "antd";
import Reviews from "./sub-tabs/reviews";
import SocialMedia from "./sub-tabs/social-media";
import Address from "./sub-tabs/Address";
import GettingToUs from "./sub-tabs/GettingToUs";
import PersonalInfoForm from "./sub-tabs/PersonalInfoForm";

const tabList = [
  {
    tabName: "Reviews",
    component: () => <Reviews />,
    tabKey: contactUSkeys.reviews,
  },
  {
    tabName: "Social media",
    component: (params) => <SocialMedia {...params} />,
    tabKey: contactUSkeys.socialMedia,
  },
  {
    tabName: "Sales",
    component: (params) => <Sales {...params} />,
    tabKey: contactUSkeys.sales,
  },
  {
    tabName: "Customer services",
    component: (params) => <PersonalInfoForm {...params} />,
    tabKey: contactUSkeys.customerService,
  },
  {
    tabName: "Careers",
    component: (params) => <HR {...params} />,
    tabKey: contactUSkeys.hr,
  },
  {
    tabName: "Contracts",
    component: (params) => <PersonalInfoForm {...params} />,
    tabKey: contactUSkeys.contracts,
  },
  {
    tabName: "Experiences of work",
    component: (params) => <EOW {...params} />,
    tabKey: contactUSkeys.eow,
  },
  {
    tabName: "Volunteering",
    component: (params) => <PersonalInfoForm {...params} />,
    tabKey: contactUSkeys.volunteering,
  },
  {
    tabName: "Addresses",
    component: (params) => <Address {...params} />,
    tabKey: contactUSkeys.address,
  },
  {
    tabName: "Getting to us",
    component: (params) => <GettingToUs {...params} />,
    tabKey: contactUSkeys.gettingToUs,
  },
];

export default function ContactUsComponent({
  dataLoader,
  form,
  handleTabs,
  splitParams,
}) {
  const [activeKey, setActiveKey] = useState();

  useEffect(() => {
    setActiveKey(
      splitParams?.length > 1 ? splitParams[1] : contactUSkeys.sales
    );
  }, [splitParams]);

  return (
    <div className="contact-tab-container">
      <Tabs
        className="tabBodyContainer"
        onChange={handleTabs}
        activeKey={activeKey}
      >
        {tabList.map((tab) => {
          return (
            <Tabs.TabPane
              className="contactUsContent contact-tab-content-container"
              tab={tab.tabName}
              key={tab.tabKey}
            >
              {tab.component({
                dataLoader,
                form,
                tabKey: activeKey,
              })}
            </Tabs.TabPane>
          );
        })}
      </Tabs>
    </div>
  );
}
